export const constants = {
  MFE_LOGIN_NAME: 'login',
  MFE_EXPOSED_PATH: './LoginApp',
  MFE_MOBILE_EXPOSED_PATH: './LoginMobile',
};
